import {Mobile, PC, Tablet, Notebook} from "../../ReactiveMode"
import PageHeader from "../../../components/common/PageHeader"
import "../../../resources/scss/church-organization.scss"

const ChurchOrganization = () => {
    // CDN URL 가져오기
    const CDN_URL = process.env.REACT_APP_CDN_URL || "https://cdn.plzez.com"

    // 이미지 URL 생성 함수
    const getImageUrl = (imagePath, fallback = null) => {
        if (!imagePath) return fallback || "/images/placeholder.svg?height=120&width=100&query=portrait"

        // 이미 전체 URL인 경우 그대로 반환
        if (imagePath.startsWith("http")) return imagePath

        // CDN URL과 조합
        return `${CDN_URL}${imagePath.startsWith("/") ? "" : "/"}${imagePath}`
    }

    // 원로목사 이력
    const seniorPastorHistory = [
        "1951.1.28 충북 괴산 출생",
        "1984.6.11 의정부시 의정부동 247-17 성실교회 설립",
        "1985.10.5 강도사 인허",
        "1985.2.28 웨스트민스터 신학대학원 졸업",
        "1986.10.7 목사 임직",
        "1996.9 장신 신학원 이사 역임",
        "1996.9.15 경기북노회 노회장 4년 역임",
        "2001 경기도 경찰청 경목 위원 역임",
        "2006 북서울 노회 노회장 역임",
        "2007 북서울 노회 교역자 회장 역임",
        "2010.1.26 21C 목회성장연구소 이사",
        "2025.5.25 원로목사 추대",
    ]

    // 담임목사 이력
    const pastorHistory = [
        "1991.11.23 경기 의정부 출생",
        "2017.02.15 총신대학교 신학과 졸업",
        "2023.02.14 합동신학대학원 졸업(M.div)",
        "2023.10.16 강도사 인허",
        "2024.10.14 목사 임직",
        "2025.11.02 성실교회 담임 목사 위임",
    ]

    // 원로목사 정보
    const seniorPastor = {
        name: "염종석 원로목사",
        image: "images/organization/0.jpg", // CDN에서 가져올 이미지 경로
        fallbackImage: "/images/placeholder.svg?height=200&width=160&query=senior pastor portrait",
    }

    // 담임목사 정보
    const pastor = {
        name: "김진영 담임목사",
        image: "images/organization/1.jpg", // CDN에서 가져올 이미지 경로
        fallbackImage: "/images/placeholder.svg?height=200&width=160&query=pastor portrait",
    }

    const evangelists = [
        {
            name: "손모아",
            position: "교육전도사",
            responsibility: "유치부 담당",
            image: "images/organization/3.jpg", // CDN 경로
            fallbackImage: "/images/placeholder.svg?height=150&width=120&query=evangelist portrait",
        },
        {
            name: "조성빈",
            position: "교육전도사",
            responsibility: "청소년부 담당",
            image: "images/organization/4.jpg", // CDN 경로
            fallbackImage: "/images/placeholder.svg?height=150&width=120&query=evangelist portrait",
        },
    ]

    const staff = [
        {
            name: "문동근 장로",
            position: "사무장",
            image: "images/organization/9.png", // CDN 경로
            fallbackImage: "/images/placeholder.svg?height=120&width=100&query=staff portrait",
        }, {
            name: "김은배 장로",
            position: "시설관리",
            image: "images/organization/6.jpg", // CDN 경로
            fallbackImage: "/images/placeholder.svg?height=120&width=100&query=staff portrait",
        },
        {
            name: "신강자 권사",
            position: "사무간사",
            image: "images/organization/5.jpg", // CDN 경로
            fallbackImage: "/images/placeholder.svg?height=120&width=100&query=staff portrait",
        }
    ]

    // 장로님들도 CDN 이미지 경로로 설정
    const activeElders = [
        {
            name: "김윤진 장로",
            position: "시무장로, 위원회",
            responsibility: "재정 위원장",
            image: "images/organization/8.jpg", // CDN 경로
            fallbackImage: "/images/placeholder.svg?height=120&width=100&query=elder portrait",
        }, {
            name: "김은배 장로",
            position: "시무장로, 위원회",
            responsibility: "관리위원장",
            image: "images/organization/6.jpg", // CDN 경로
            fallbackImage: "/images/placeholder.svg?height=120&width=100&query=elder portrait",
        }, {
            name: "문동근 장로",
            position: "시무장로, 위원회",
            responsibility: "행정 위원장",
            image: "images/organization/9.png", // CDN 경로
            fallbackImage: "/images/placeholder.svg?height=120&width=100&query=elder portrait",
        },
        {
            name: "백승익 장로",
            position: "시무장로, 위원회",
            responsibility: "예배위원장",
            image: "images/organization/7.jpg", // CDN 경로
            fallbackImage: "/images/placeholder.svg?height=120&width=100&query=elder portrait",
        },
        {
            name: "임민섭 장로",
            position: "시무장로, 위원회",
            responsibility: "교육 위원장",
            image: "images/organization/10.jpg", // CDN 경로
            fallbackImage: "/images/placeholder.svg?height=120&width=100&query=elder portrait",
        },

    ]

    const retiredElders = [
        {
            name: "김기환 장로",
            position: "은퇴장로",
            responsibility: "원로 고문",
            image: "images/organization/11.jpg", // CDN 경로
            fallbackImage: "/images/placeholder.svg?height=120&width=100&query=elder portrait",
        },
        {
            name: "김영수 장로",
            position: "은퇴장로",
            responsibility: "원로 고문",
            image: "images/organization/17.jpeg", // CDN 경로
            fallbackImage: "/images/placeholder.svg?height=120&width=100&query=elder portrait",
        },
    ]

    // 이미지 로딩 에러 처리 함수
    const handleImageError = (e, fallbackImage) => {
        e.target.src = fallbackImage
    }

    return (
        <>
            <PC>
                <div className="pf-page church-organization">


                    <div className="background">
                        <div className="layout">
                            {/* 원로목사 소개 */}
                            <section className="pastor-section">
                                <h2 className="section-title">원로 목사</h2>
                                <div className="pastor-card">
                                    <div className="pastor-info">
                                        <div className="pastor-photo">
                                            <img
                                                src={getImageUrl(seniorPastor.image, seniorPastor.fallbackImage) || "/placeholder.svg"}
                                                alt={seniorPastor.name}
                                                onError={(e) => handleImageError(e, seniorPastor.fallbackImage)}
                                            />
                                        </div>
                                        <div className="pastor-details">
                                            <h3>{seniorPastor.name}</h3>
                                            <div className="pastor-history">
                                                <h4>이력</h4>
                                                <ul>
                                                    {seniorPastorHistory.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* 담임목사 소개 */}
                            <section className="pastor-section">
                                <h2 className="section-title">담임 목사</h2>
                                <div className="pastor-card">
                                    <div className="pastor-info">
                                        <div className="pastor-photo">
                                            <img
                                                src={getImageUrl(pastor.image, pastor.fallbackImage) || "/placeholder.svg"}
                                                alt={pastor.name}
                                                onError={(e) => handleImageError(e, pastor.fallbackImage)}
                                            />
                                        </div>
                                        <div className="pastor-details">
                                            <h3>{pastor.name}</h3>
                                            <div className="pastor-history">
                                                <h4>이력</h4>
                                                <ul>
                                                    {pastorHistory.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* 교육전도사 소개 */}
                            <section className="evangelists-section">
                                <h2 className="section-title">교육전도사</h2>
                                <div className="evangelists-grid">
                                    {evangelists.map((evangelist, index) => (
                                        <div key={index} className="evangelist-card">
                                            <div className="evangelist-photo">
                                                <img
                                                    src={getImageUrl(evangelist.image, evangelist.fallbackImage) || "/placeholder.svg"}
                                                    alt={evangelist.name}
                                                    onError={(e) => handleImageError(e, evangelist.fallbackImage)}
                                                />
                                            </div>
                                            <div className="evangelist-info">
                                                <h4>{evangelist.name}</h4>
                                                <p className="position">{evangelist.position}</p>
                                                <p className="responsibility">{evangelist.responsibility}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>

                            {/* 직원 소개 */}
                            <section className="staff-section">
                                <h2 className="section-title">직원</h2>
                                <div className="staff-grid">
                                    {staff.map((member, index) => (
                                        <div key={index} className="staff-card">
                                            <div className="staff-photo">
                                                <img
                                                    src={getImageUrl(member.image, member.fallbackImage) || "/placeholder.svg"}
                                                    alt={member.name}
                                                    onError={(e) => handleImageError(e, member.fallbackImage)}
                                                />
                                            </div>
                                            <div className="staff-info">
                                                <h4>{member.name}</h4>
                                                <p className="position">{member.position}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>

                            {/* 장로 소개 - CDN 이미지 사용 */}
                            <section className="elders-section">
                                <h2 className="section-title">장로</h2>
                                <div className="elders-container">
                                    <div className="active-elders">
                                        <h3>시무장로, 위원회</h3>
                                        <div className="elders-grid">
                                            {activeElders.map((elder, index) => (
                                                <div key={index} className="elder-card enhanced-elder-card">
                                                    <div className="elder-photo">
                                                        <img
                                                            src={getImageUrl(elder.image, elder.fallbackImage) || "/placeholder.svg"}
                                                            alt={elder.name}
                                                            onError={(e) => handleImageError(e, elder.fallbackImage)}
                                                        />
                                                    </div>
                                                    <div className="elder-info">
                                                        <h4>{elder.name}</h4>
                                                        <p className="position">{elder.position}</p>
                                                        {elder.responsibility &&
                                                            <p className="responsibility">{elder.responsibility}</p>}
                                                        {elder.description &&
                                                            <p className="description">{elder.description}</p>}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="retired-elders">
                                        <h3>은퇴장로</h3>
                                        <div className="elders-grid">
                                            {retiredElders.map((elder, index) => (
                                                <div key={index} className="elder-card enhanced-elder-card">
                                                    <div className="elder-photo">
                                                        <img
                                                            src={getImageUrl(elder.image, elder.fallbackImage) || "/placeholder.svg"}
                                                            alt={elder.name}
                                                            onError={(e) => handleImageError(e, elder.fallbackImage)}
                                                        />
                                                    </div>
                                                    <div className="elder-info">
                                                        <h4>{elder.name}</h4>
                                                        <p className="position">{elder.position}</p>
                                                        {elder.responsibility &&
                                                            <p className="responsibility">{elder.responsibility}</p>}
                                                        {elder.description &&
                                                            <p className="description">{elder.description}</p>}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </PC>

            {/* Notebook, Tablet, Mobile 버전도 동일하게 적용 */}
            <Notebook>
                <div className="pf-page church-organization notebook-organization">

                    <div className="background">
                        <div className="layout">
                            {/* 원로목사 소개 */}
                            <section className="pastor-section">
                                <h2 className="section-title">원로목사</h2>
                                <div className="pastor-card notebook-pastor-card">
                                    <div className="pastor-info">
                                        <div className="pastor-photo">
                                            <img
                                                src={
                                                    getImageUrl(
                                                        seniorPastor.image,
                                                        "/images/placeholder.svg?height=180&width=140&query=senior pastor portrait",
                                                    ) || "/placeholder.svg"
                                                }
                                                alt={seniorPastor.name}
                                                onError={(e) =>
                                                    handleImageError(e, "/images/placeholder.svg?height=180&width=140&query=senior pastor portrait")
                                                }
                                            />
                                        </div>
                                        <div className="pastor-details">
                                            <h3>{seniorPastor.name}</h3>
                                            <div className="pastor-history">
                                                <h4>이력</h4>
                                                <ul>
                                                    {seniorPastorHistory.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* 담임목사 소개 */}
                            <section className="pastor-section">
                                <h2 className="section-title">담임목사</h2>
                                <div className="pastor-card notebook-pastor-card">
                                    <div className="pastor-info">
                                        <div className="pastor-photo">
                                            <img
                                                src={
                                                    getImageUrl(
                                                        pastor.image,
                                                        "/images/placeholder.svg?height=180&width=140&query=pastor portrait",
                                                    ) || "/placeholder.svg"
                                                }
                                                alt={pastor.name}
                                                onError={(e) =>
                                                    handleImageError(e, "/images/placeholder.svg?height=180&width=140&query=pastor portrait")
                                                }
                                            />
                                        </div>
                                        <div className="pastor-details">
                                            <h3>{pastor.name}</h3>
                                            <div className="pastor-history">
                                                <h4>이력</h4>
                                                <ul>
                                                    {pastorHistory.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* 교육전도사 소개 */}
                            <section className="evangelists-section">
                                <h2 className="section-title">교육전도사</h2>
                                <div className="evangelists-grid notebook-evangelists-grid">
                                    {evangelists.map((evangelist, index) => (
                                        <div key={index} className="evangelist-card">
                                            <div className="evangelist-photo">
                                                <img
                                                    src={
                                                        getImageUrl(
                                                            evangelist.image,
                                                            "/images/placeholder.svg?height=130&width=110&query=evangelist portrait",
                                                        ) || "/placeholder.svg"
                                                    }
                                                    alt={evangelist.name}
                                                    onError={(e) =>
                                                        handleImageError(
                                                            e,
                                                            "/images/placeholder.svg?height=130&width=110&query=evangelist portrait",
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div className="evangelist-info">
                                                <h4>{evangelist.name}</h4>
                                                <p className="position">{evangelist.position}</p>
                                                <p className="responsibility">{evangelist.responsibility}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>

                            {/* 직원 소개 */}
                            <section className="staff-section">
                                <h2 className="section-title">직원</h2>
                                <div className="staff-grid notebook-staff-grid">
                                    {staff.map((member, index) => (
                                        <div key={index} className="staff-card">
                                            <div className="staff-photo">
                                                <img
                                                    src={
                                                        getImageUrl(
                                                            member.image,
                                                            "/images/placeholder.svg?height=110&width=90&query=staff portrait",
                                                        ) || "/placeholder.svg"
                                                    }
                                                    alt={member.name}
                                                    onError={(e) =>
                                                        handleImageError(e, "/images/placeholder.svg?height=110&width=90&query=staff portrait")
                                                    }
                                                />
                                            </div>
                                            <div className="staff-info">
                                                <h4>{member.name}</h4>
                                                <p className="position">{member.position}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>

                            {/* 장로 소개 */}
                            <section className="elders-section">
                                <h2 className="section-title">장로</h2>
                                <div className="elders-container">
                                    <div className="active-elders">
                                        <h3>시무장로, 위원회</h3>
                                        <div className="elders-grid notebook-elders-grid">
                                            {activeElders.map((elder, index) => (
                                                <div key={index} className="elder-card enhanced-elder-card">
                                                    <div className="elder-photo">
                                                        <img
                                                            src={
                                                                getImageUrl(
                                                                    elder.image,
                                                                    "/images/placeholder.svg?height=110&width=90&query=elder portrait",
                                                                ) || "/placeholder.svg"
                                                            }
                                                            alt={elder.name}
                                                            onError={(e) =>
                                                                handleImageError(e, "/images/placeholder.svg?height=110&width=90&query=elder portrait")
                                                            }
                                                        />
                                                    </div>
                                                    <div className="elder-info">
                                                        <h4>{elder.name}</h4>
                                                        <p className="position">{elder.position}</p>
                                                        {elder.responsibility &&
                                                            <p className="responsibility">{elder.responsibility}</p>}
                                                        {elder.description &&
                                                            <p className="description">{elder.description}</p>}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="retired-elders">
                                        <h3>은퇴장로</h3>
                                        <div className="elders-grid notebook-elders-grid">
                                            {retiredElders.map((elder, index) => (
                                                <div key={index} className="elder-card enhanced-elder-card">
                                                    <div className="elder-photo">
                                                        <img
                                                            src={
                                                                getImageUrl(
                                                                    elder.image,
                                                                    "/images/placeholder.svg?height=110&width=90&query=elder portrait",
                                                                ) || "/placeholder.svg"
                                                            }
                                                            alt={elder.name}
                                                            onError={(e) =>
                                                                handleImageError(e, "/images/placeholder.svg?height=110&width=90&query=elder portrait")
                                                            }
                                                        />
                                                    </div>
                                                    <div className="elder-info">
                                                        <h4>{elder.name}</h4>
                                                        <p className="position">{elder.position}</p>
                                                        {elder.responsibility &&
                                                            <p className="responsibility">{elder.responsibility}</p>}
                                                        {elder.description &&
                                                            <p className="description">{elder.description}</p>}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </Notebook>

            <Tablet>
                <div className="pf-page church-organization tablet-organization">

                    <div className="background">
                        <div className="layout">
                            {/* 원로목사 소개 */}
                            <section className="pastor-section">
                                <h2 className="section-title">원로목사</h2>
                                <div className="pastor-card tablet-pastor-card">
                                    <div className="pastor-info">
                                        <div className="pastor-photo">
                                            <img
                                                src={
                                                    getImageUrl(
                                                        seniorPastor.image,
                                                        "/images/placeholder.svg?height=160&width=130&query=senior pastor portrait",
                                                    ) || "/placeholder.svg"
                                                }
                                                alt={seniorPastor.name}
                                                onError={(e) =>
                                                    handleImageError(e, "/images/placeholder.svg?height=160&width=130&query=senior pastor portrait")
                                                }
                                            />
                                        </div>
                                        <div className="pastor-details">
                                            <h3>{seniorPastor.name}</h3>
                                            <div className="pastor-history">
                                                <h4>이력</h4>
                                                <ul>
                                                    {seniorPastorHistory.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* 담임목사 소개 */}
                            <section className="pastor-section">
                                <h2 className="section-title">담임목사</h2>
                                <div className="pastor-card tablet-pastor-card">
                                    <div className="pastor-info">
                                        <div className="pastor-photo">
                                            <img
                                                src={
                                                    getImageUrl(
                                                        pastor.image,
                                                        "/images/placeholder.svg?height=160&width=130&query=pastor portrait",
                                                    ) || "/placeholder.svg"
                                                }
                                                alt={pastor.name}
                                                onError={(e) =>
                                                    handleImageError(e, "/images/placeholder.svg?height=160&width=130&query=pastor portrait")
                                                }
                                            />
                                        </div>
                                        <div className="pastor-details">
                                            <h3>{pastor.name}</h3>
                                            <div className="pastor-history">
                                                <h4>이력</h4>
                                                <ul>
                                                    {pastorHistory.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* 교육전도사 소개 */}
                            <section className="evangelists-section">
                                <h2 className="section-title">교육전도사</h2>
                                <div className="evangelists-grid tablet-evangelists-grid">
                                    {evangelists.map((evangelist, index) => (
                                        <div key={index} className="evangelist-card">
                                            <div className="evangelist-photo">
                                                <img
                                                    src={
                                                        getImageUrl(
                                                            evangelist.image,
                                                            "/images/placeholder.svg?height=120&width=100&query=evangelist portrait",
                                                        ) || "/placeholder.svg"
                                                    }
                                                    alt={evangelist.name}
                                                    onError={(e) =>
                                                        handleImageError(
                                                            e,
                                                            "/images/placeholder.svg?height=120&width=100&query=evangelist portrait",
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div className="evangelist-info">
                                                <h4>{evangelist.name}</h4>
                                                <p className="position">{evangelist.position}</p>
                                                <p className="responsibility">{evangelist.responsibility}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>

                            {/* 직원 소개 */}
                            <section className="staff-section">
                                <h2 className="section-title">직원</h2>
                                <div className="staff-grid tablet-staff-grid">
                                    {staff.map((member, index) => (
                                        <div key={index} className="staff-card">
                                            <div className="staff-photo">
                                                <img
                                                    src={
                                                        getImageUrl(
                                                            member.image,
                                                            "/images/placeholder.svg?height=100&width=85&query=staff portrait",
                                                        ) || "/placeholder.svg"
                                                    }
                                                    alt={member.name}
                                                    onError={(e) =>
                                                        handleImageError(e, "/images/placeholder.svg?height=100&width=85&query=staff portrait")
                                                    }
                                                />
                                            </div>
                                            <div className="staff-info">
                                                <h4>{member.name}</h4>
                                                <p className="position">{member.position}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>

                            {/* 장로 소개 */}
                            <section className="elders-section">
                                <h2 className="section-title">장로</h2>
                                <div className="elders-container">
                                    <div className="active-elders">
                                        <h3>시무장로, 위원회</h3>
                                        <div className="elders-grid tablet-elders-grid">
                                            {activeElders.map((elder, index) => (
                                                <div key={index} className="elder-card enhanced-elder-card">
                                                    <div className="elder-photo">
                                                        <img
                                                            src={
                                                                getImageUrl(
                                                                    elder.image,
                                                                    "/images/placeholder.svg?height=100&width=85&query=elder portrait",
                                                                ) || "/placeholder.svg"
                                                            }
                                                            alt={elder.name}
                                                            onError={(e) =>
                                                                handleImageError(e, "/images/placeholder.svg?height=100&width=85&query=elder portrait")
                                                            }
                                                        />
                                                    </div>
                                                    <div className="elder-info">
                                                        <h4>{elder.name}</h4>
                                                        <p className="position">{elder.position}</p>
                                                        {elder.responsibility &&
                                                            <p className="responsibility">{elder.responsibility}</p>}
                                                        {elder.description &&
                                                            <p className="description">{elder.description}</p>}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="retired-elders">
                                        <h3>은퇴장로</h3>
                                        <div className="elders-grid tablet-elders-grid">
                                            {retiredElders.map((elder, index) => (
                                                <div key={index} className="elder-card enhanced-elder-card">
                                                    <div className="elder-photo">
                                                        <img
                                                            src={
                                                                getImageUrl(
                                                                    elder.image,
                                                                    "/images/placeholder.svg?height=100&width=85&query=elder portrait",
                                                                ) || "/placeholder.svg"
                                                            }
                                                            alt={elder.name}
                                                            onError={(e) =>
                                                                handleImageError(e, "/images/placeholder.svg?height=100&width=85&query=elder portrait")
                                                            }
                                                        />
                                                    </div>
                                                    <div className="elder-info">
                                                        <h4>{elder.name}</h4>
                                                        <p className="position">{elder.position}</p>
                                                        {elder.responsibility &&
                                                            <p className="responsibility">{elder.responsibility}</p>}
                                                        {elder.description &&
                                                            <p className="description">{elder.description}</p>}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </Tablet>

            <Mobile>
                <div className="pf-page church-organization mobile-organization">
                    <div className="background">
                        <div className="layout">
                            {/* 원로목사 소개 */}
                            <section className="pastor-section">
                                <h2 className="section-title">원로목사</h2>
                                <div className="pastor-card mobile-pastor-card">
                                    <div className="pastor-photo">
                                        <img
                                            src={
                                                getImageUrl(
                                                    seniorPastor.image,
                                                    "/images/placeholder.svg?height=140&width=110&query=senior pastor portrait",
                                                ) || "/placeholder.svg"
                                            }
                                            alt={seniorPastor.name}
                                            onError={(e) =>
                                                handleImageError(e, "/images/placeholder.svg?height=140&width=110&query=senior pastor portrait")
                                            }
                                        />
                                    </div>
                                    <div className="pastor-details">
                                        <h3>{seniorPastor.name}</h3>
                                        <div className="pastor-history">
                                            <h4>이력</h4>
                                            <ul>
                                                {seniorPastorHistory.map((item, index) => (
                                                    <li key={index}>{item}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* 담임목사 소개 */}
                            <section className="pastor-section">
                                <h2 className="section-title">담임목사</h2>
                                <div className="pastor-card mobile-pastor-card">
                                    <div className="pastor-photo">
                                        <img
                                            src={
                                                getImageUrl(
                                                    pastor.image,
                                                    "/images/placeholder.svg?height=140&width=110&query=pastor portrait",
                                                ) || "/placeholder.svg"
                                            }
                                            alt={pastor.name}
                                            onError={(e) =>
                                                handleImageError(e, "/images/placeholder.svg?height=140&width=110&query=pastor portrait")
                                            }
                                        />
                                    </div>
                                    <div className="pastor-details">
                                        <h3>{pastor.name}</h3>
                                        <div className="pastor-history">
                                            <h4>이력</h4>
                                            <ul>
                                                {pastorHistory.map((item, index) => (
                                                    <li key={index}>{item}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* 교육전도사 소개 */}
                            <section className="evangelists-section">
                                <h2 className="section-title">교육전도사</h2>
                                <div className="evangelists-grid mobile-evangelists-grid">
                                    {evangelists.map((evangelist, index) => (
                                        <div key={index} className="evangelist-card mobile-evangelist-card">
                                            <div className="evangelist-photo">
                                                <img
                                                    src={
                                                        getImageUrl(
                                                            evangelist.image,
                                                            "/images/placeholder.svg?height=100&width=80&query=evangelist portrait",
                                                        ) || "/placeholder.svg"
                                                    }
                                                    alt={evangelist.name}
                                                    onError={(e) =>
                                                        handleImageError(e, "/images/placeholder.svg?height=100&width=80&query=evangelist portrait")
                                                    }
                                                />
                                            </div>
                                            <div className="evangelist-info">
                                                <h4>{evangelist.name}</h4>
                                                <p className="position">{evangelist.position}</p>
                                                <p className="responsibility">{evangelist.responsibility}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>

                            {/* 직원 소개 */}
                            <section className="staff-section">
                                <h2 className="section-title">직원</h2>
                                <div className="staff-grid mobile-staff-grid">
                                    {staff.map((member, index) => (
                                        <div key={index} className="staff-card mobile-staff-card">
                                            <div className="staff-photo">
                                                <img
                                                    src={
                                                        getImageUrl(
                                                            member.image,
                                                            "/images/placeholder.svg?height=90&width=70&query=staff portrait",
                                                        ) || "/placeholder.svg"
                                                    }
                                                    alt={member.name}
                                                    onError={(e) =>
                                                        handleImageError(e, "/images/placeholder.svg?height=90&width=70&query=staff portrait")
                                                    }
                                                />
                                            </div>
                                            <div className="staff-info">
                                                <h4>{member.name}</h4>
                                                <p className="position">{member.position}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>

                            {/* 장로 소개 */}
                            <section className="elders-section">
                                <h2 className="section-title">장로</h2>
                                <div className="elders-container">
                                    <div className="active-elders">
                                        <h3>시무장로, 위원회</h3>
                                        <div className="elders-grid mobile-elders-grid">
                                            {activeElders.map((elder, index) => (
                                                <div key={index}
                                                     className="elder-card mobile-elder-card enhanced-elder-card">
                                                    <div className="elder-photo">
                                                        <img
                                                            src={
                                                                getImageUrl(
                                                                    elder.image,
                                                                    "/images/placeholder.svg?height=90&width=70&query=elder portrait",
                                                                ) || "/placeholder.svg"
                                                            }
                                                            alt={elder.name}
                                                            onError={(e) =>
                                                                handleImageError(e, "/images/placeholder.svg?height=90&width=70&query=elder portrait")
                                                            }
                                                        />
                                                    </div>
                                                    <div className="elder-info">
                                                        <h4>{elder.name}</h4>
                                                        <p className="position">{elder.position}</p>
                                                        {elder.responsibility &&
                                                            <p className="responsibility">{elder.responsibility}</p>}
                                                        {elder.description &&
                                                            <p className="description">{elder.description}</p>}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="retired-elders">
                                        <h3>은퇴장로</h3>
                                        <div className="elders-grid mobile-elders-grid">
                                            {retiredElders.map((elder, index) => (
                                                <div key={index}
                                                     className="elder-card mobile-elder-card enhanced-elder-card">
                                                    <div className="elder-photo">
                                                        <img
                                                            src={
                                                                getImageUrl(
                                                                    elder.image,
                                                                    "/images/placeholder.svg?height=90&width=70&query=elder portrait",
                                                                ) || "/placeholder.svg"
                                                            }
                                                            alt={elder.name}
                                                            onError={(e) =>
                                                                handleImageError(e, "/images/placeholder.svg?height=90&width=70&query=elder portrait")
                                                            }
                                                        />
                                                    </div>
                                                    <div className="elder-info">
                                                        <h4>{elder.name}</h4>
                                                        <p className="position">{elder.position}</p>
                                                        {elder.responsibility &&
                                                            <p className="responsibility">{elder.responsibility}</p>}
                                                        {elder.description &&
                                                            <p className="description">{elder.description}</p>}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </Mobile>
        </>
    )
}

export default ChurchOrganization
